import { regionData } from 'element-china-area-data'

export function listProvinces() {
  return regionData.map(p => p.label)
}

export function listCities(provinceLabel) {
  if (!provinceLabel) return []
  const p = regionData.find(x => x.label === provinceLabel)
  if (!p || !p.children) return []
  return p.children.map(c => c.label)
}

export function listDistricts(provinceLabel, cityLabel) {
  if (!provinceLabel || !cityLabel) return []
  const p = regionData.find(x => x.label === provinceLabel)
  if (!p || !p.children) return []
  const c = p.children.find(x => x.label === cityLabel)
  if (!c || !c.children) return []
  return c.children.map(d => d.label)
}
